// The verified screens (email code, phone) move on by themselves after a short
// count, shown on the Continue button ("Continue in 3…"), which still works for
// anyone who'd rather not wait. Membership's phone step waits 1s and the legacy
// email step 4s; 3s leaves time to read the success line.

import { useEffect, useRef, useState } from "react";
import i18next from "i18next";

export const AUTO_CONTINUE_SECONDS = 3;

export const useAutoContinue = (onDone: () => void) => {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const timer = useRef<any>(null);
  const done = useRef(onDone);
  done.current = onDone;

  const stop = () => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }
    setSecondsLeft(0);
  };

  const start = () => {
    stop();
    setSecondsLeft(AUTO_CONTINUE_SECONDS);
    timer.current = setInterval(() => setSecondsLeft((n) => n - 1), 1000);
  };

  useEffect(() => {
    if (timer.current && secondsLeft <= 0) {
      clearInterval(timer.current);
      timer.current = null;
      done.current();
    }
  }, [secondsLeft]);

  useEffect(
    () => () => {
      if (timer.current) clearInterval(timer.current);
    },
    []
  );

  return { secondsLeft, start, stop };
};

/** "Continue in 3…" while counting, "Continue" otherwise. */
export const autoContinueLabel = (secondsLeft: number) =>
  secondsLeft > 0
    ? i18next.t("Continue in {{count}}…", { count: secondsLeft })
    : i18next.t("Continue");
